import { isAccountSharingReadonlyMode } from 'system/SystemUtil';
import { createMenuItem } from 'utils/navigation/helpers';

const buildSocialMenuSection = ({ userType }) => {
    return [
        createMenuItem({
            title: 'connections',
            translationNamespace: 'userprofile',
            icon: 'people-2',
            url: '/connections/connections',
            urlKeyword: 'search',
            disabled: isAccountSharingReadonlyMode(),
            condition: userType.isFitness || userType.isWellness || userType.isDive || userType.isOutdoor
        }),
        createMenuItem({
            title: 'title_groups_widget',
            translationNamespace: 'widgets',
            icon: 'people-3',
            url: '/groups',
            urlKeyword: 'group/',
            disabled: isAccountSharingReadonlyMode(),
            condition: userType.isFitness || userType.isWellness || userType.isDive || userType.isOutdoor
        })
    ].flat();
};

export default buildSocialMenuSection;
